export default function Shoe({ color = "#3E3E3E", width = "24", height = "24" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10.2585 8.11929H12L13.3573 7.29228C13.5741 7.1602 13.8393 7.13412 14.0777 7.22143C14.3161 7.30874 14.5017 7.49993 14.5819 7.7408L16.5019 13.5007L19.203 17.1022C19.5441 17.5569 19.5989 18.1653 19.3447 18.6737C19.0905 19.1821 18.5709 19.5032 18.0025 19.5032H14.7262C13.7997 19.5038 12.9148 19.1183 12.2843 18.4394L5.16384 10.7754C4.70142 10.2767 4.46206 9.6111 4.50091 8.93208C4.53976 8.25306 4.85348 7.61915 5.36976 7.1764L8.22345 4.73122C8.50996 4.48579 8.91311 4.42955 9.25585 4.58722C9.59858 4.74488 9.81821 5.0876 9.81828 5.46486V8.11929H12"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.49683 16.5853H6.16419"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66523 19.5033H4.49683"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1255 17.0021H14.9371C14.2431 17.004 13.5799 16.7156 13.108 16.2068L5.04297 7.52148"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8337 12.8336L16.0893 12.2701"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 10.7494L15.3881 10.1634"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
